import { isOfferMarkerType, type MapMarkerComponent } from 'tripPlanner/utils/mapMarkerTransforms'

/** Shared cluster eligibility for the full and drawer presentations. */
export function isUnclusteredMapMarker(
  marker: MapMarkerComponent,
  focusedMarkerId?: string,
  focusedItemId?: number,
): boolean {
  return isOfferMarkerType(marker.markerType) ||
    (focusedItemId !== undefined
      ? marker.itemId === focusedItemId
      : focusedMarkerId !== undefined && marker.markerId === focusedMarkerId)
}
